<template>
  <s-task-list-layout
    :title="$t('PublicServant.Me.AL.DAFConfirmed')"
    back-u-r-l="/tasklist/eDocInternalHistory"
  >
    <s-int-history-detail
      v-if="detailPageObj"
      :item="detailPageObj"
      @finish="$router.push('/tasklist/eDocInternalHistory')"
    />

    <br><br><br><br><br><br>
  </s-task-list-layout>
</template>

<script>

import STaskListLayout from './components/STaskListLayout'
import SIntHistoryDetail from './components/eDocInternalHistory/SIntHistoryDetail'
import docFlowApi from '@/api/eDocInternal/docFlow'
import { docFlowModule, commonComponentModule } from '@/store/moduleName'
import { DOC_FLOW_TYPE, TASK_LIST_JOB_TYPE, INFLOW_STATUS_CODES } from '@/constant/constant'
import { mapMutations } from 'vuex'

export default {
  components: {
    STaskListLayout,
    SIntHistoryDetail
  },
  props: {
    processId: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      detailPageObj: null
    }
  },
  computed: {

  },
  watch: {
    $route: {
      handler: function (route) {
        this.clearSecurityFileKeys() // clear file keys in store
      },
      deep: true,
      immediate: true // Since this function doesn't work when leaving this page, clear security file keys when enter this page
    }
  },
  created () {
    this.$store.commit(docFlowModule + '/setTaskListJobType', TASK_LIST_JOB_TYPE.MY_JOB)
    this.$store.commit(docFlowModule + '/setInflowStatus', [INFLOW_STATUS_CODES.ACTIVE, INFLOW_STATUS_CODES.VOID])
    this.$store.commit(docFlowModule + '/setDocFlowType', DOC_FLOW_TYPE.DOC_FLOW)
  },
  async mounted () {
    await docFlowApi.getDfProcessListItemDetail(resp => {
      this.detailPageObj = resp.data
    }, this.processId)
  },
  methods: {
    ...mapMutations(commonComponentModule, ['clearSecurityFileKeys'])
  }
}
</script>
